import {useAttendeeVariables} from 'Event'
import {useAddTranslation} from 'Event/LanguageProvider'
import {useSimpleBlogTemplate} from 'Event/template/SimpleBlog'
import {useSaveTemplate} from 'Event/TemplateUpdateProvider'
import {replaceAtPath} from 'lib/JsonUpdateProvider'
import ColorPicker from 'lib/ui/ColorPicker'
import TextField from 'lib/ui/TextField'
import {useConfig} from 'organization/Event/Configurable'
import Config from 'organization/Event/Configurable/Config'
import SettingsPanel from 'organization/Event/DashboardConfig/ComponentConfigPanel/SettingsPanel'
import StylingPanel from 'organization/Event/DashboardConfig/ComponentConfigPanel/StylingPanel'
import React from 'react'
import {Controller} from 'react-hook-form'

export default function DashboardLinkConfig() {
  const saveTemplate = useSaveTemplate()
  const {zoomBackgrounds} = useSimpleBlogTemplate()
  const addTranslation = useAddTranslation()
  const v = useAttendeeVariables()

  const {
    form: {control, register},
  } = useConfig()

  const save = (data: any) => {
    const text = replaceAtPath(
      data,
      'zoomBackgrounds.backToDashboardText',
      '{{zoom_backgrounds_back_to_dashboard_text}}',
    )

    saveTemplate({
      ...data,
      localization: addTranslation({
        zoom_backgrounds_back_to_dashboard_text: text ?? '',
      }),
    })
  }

  return (
    <Config title="Dashboard Link" onSave={save}>
      <SettingsPanel>
        <TextField
          defaultValue={zoomBackgrounds.backToDashboardText}
          name="zoomBackgrounds.backToDashboardText"
          label="Back to Dashboard Text"
          fullWidth
          inputProps={{
            ref: register,
            'aria-label': 'back to dashboard text',
          }}
        />
      </SettingsPanel>
      <StylingPanel>
        <Controller
          name="zoomBackgrounds.backToDashboardTextColor"
          defaultValue={v(zoomBackgrounds.backToDashboardTextColor)}
          control={control}
          render={({onChange, value}) => (
            <ColorPicker
              label="Back to Dashboard Text Color"
              color={value}
              onPick={onChange}
              aria-label="text color"
            />
          )}
        />
      </StylingPanel>
    </Config>
  )
}
